import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import * as React from 'react';

export interface CustomDialogTitleProps {
    id?: string;
    children?: React.ReactNode;
    onClose: () => void;
    rightMargin?: string;
}

export const CustomDialogTitle = (props: CustomDialogTitleProps) => {
    const { children, onClose, rightMargin, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            <div style={{marginRight: rightMargin !== undefined ? rightMargin : "20px"}}>{children}</div>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 11,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};
